export default "__VITE_ASSET__APGez6EU__"